import { render } from "./ISwitch.vue?vue&type=template&id=23dab40e"
import script from "./ISwitch.vue?vue&type=script&lang=js"
export * from "./ISwitch.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\germa\\dev\\dcpower.client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__